module.exports = __webpack_public_path__ + "static/media/StressUncertaintyPanel.3e0bb96e.png";